import { Employee } from './Employee';

export class SearchEmployeeModel {
    employees: Employee[];
}